import { apiClient } from "@/api/apiClient";

const RESOURCE = "communications/postings";

export const fetchPostingByIdAsync = (id: number, clientConfig = {}) => {
  return apiClient(clientConfig).get(`${RESOURCE}/${id}`);
};
